/* Produkt-Bulletpoints: Info-Popup (snippets/product-bullets.liquid) */
(function () {
  if (customElements.get('kb-bullets')) return;

  var supportsModal = typeof HTMLDialogElement !== 'undefined'
    && typeof HTMLDialogElement.prototype.showModal === 'function';

  /* Gemeinsame Scroll-Sperre.
   *
   * NICHT body.style.overflow anfassen: assets/vendor.js (die Drawer-/Cart-
   * Sperre des Themes) schreibt denselben Inline-Style und merkt sich dessen
   * vorherigen Wert. Zwei unabhaengige Schreiber ueberschreiben sich
   * gegenseitig - oeffnet sich ein Drawer, waehrend unser Popup offen ist,
   * merkt sich vendor.js "hidden" als Ausgangswert und stellt das beim
   * Schliessen wieder her: die Seite bleibt dauerhaft ungescrollt.
   *
   * Stattdessen eine eigene Klasse mit Zaehler. vendor.js behaelt seinen
   * Inline-Wert, wir entfernen beim Freigeben nur unsere Klasse.
   */
  var scrollLock = window.__kbScrollLock || (function () {
    var CLASS = 'kb-scroll-locked';
    var STYLE_ID = 'kb-scroll-lock-style';
    var holders = 0;

    function ensureStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      // !important, damit ein spaeter gesetzter Inline-Style die Sperre nicht aufhebt.
      style.textContent = 'html.' + CLASS + ',html.' + CLASS + '>body{overflow:hidden!important}';
      (document.head || document.documentElement).appendChild(style);
    }

    var api = {
      lock: function () {
        ensureStyle();
        holders += 1;
        document.documentElement.classList.add(CLASS);
      },
      release: function () {
        holders = Math.max(0, holders - 1);
        if (holders === 0) document.documentElement.classList.remove(CLASS);
      }
    };

    window.__kbScrollLock = api;
    return api;
  })();

  class KbBullets extends HTMLElement {
    connectedCallback() {
      // Delegation: überlebt Re-Renders im Theme-Editor ohne doppelte Listener.
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      if (!supportsModal) {
        this.querySelectorAll('dialog').forEach(function (dialog) {
          dialog.setAttribute('data-fallback', '');
        });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.unlockScroll();
    }

    onClick = (event) => {
      var opener = event.target.closest('[data-kb-bullets-open]');
      if (opener) {
        this.open(document.getElementById(opener.getAttribute('data-kb-bullets-open')), opener);
        return;
      }

      if (event.target.closest('[data-kb-bullets-close]')) {
        this.close(event.target.closest('dialog'));
        return;
      }

      // Klick auf den Backdrop: Ziel ist dann das <dialog> selbst, nicht sein Inhalt.
      if (event.target.matches('dialog.kb-bullets__dialog')) {
        this.close(event.target);
      }
    };

    onKeydown = (event) => {
      // Nur für den Fallback nötig – natives showModal() behandelt Escape selbst.
      if (event.key !== 'Escape' || supportsModal) return;
      var dialog = event.target.closest('dialog[open]');
      if (dialog) this.close(dialog);
    };

    lockScroll() {
      if (this.locked) return;
      this.locked = true;
      scrollLock.lock();
    }

    unlockScroll() {
      if (!this.locked) return;
      this.locked = false;
      scrollLock.release();
    }

    open(dialog, opener) {
      if (!dialog || dialog.open) return;
      this.opener = opener;
      this.lockScroll();

      if (supportsModal) {
        // Escape schliesst den Dialog am JS vorbei – deshalb am close-Event
        // aufräumen und nicht in close().
        dialog.addEventListener('close', this.onDialogClose, { once: true });
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
        var focusable = dialog.querySelector('[data-kb-bullets-close]');
        if (focusable) focusable.focus();
      }
    }

    close(dialog) {
      if (!dialog) return;
      if (supportsModal) {
        dialog.close(); // löst onDialogClose aus
      } else {
        dialog.removeAttribute('open');
        this.onDialogClose();
      }
    }

    onDialogClose = () => {
      this.unlockScroll();
      // Fokus zurück auf den auslösenden Button.
      if (this.opener && this.contains(this.opener)) this.opener.focus();
      this.opener = null;
    };
  }

  customElements.define('kb-bullets', KbBullets);
})();
